import $ from 'jquery';
import AOS from 'aos';

class Aos {
  constructor() {
    this.clearContainer = $('.js-aos-clear-delays');
    this.doc = $(document);

    this.heroVideo();

    this.headings();
    this.paragraphs();
    this.events();

    $(window).on('load', () => {
      AOS.init({
        easing: 'ease-in-out-cubic',
        once: true,
        duration: 800,
      });

      this.clearDelays();

      this.video.html(this.videoEmbed);
    });
  }

  heroVideo() {
    this.video = $('.js-hero-image-video');

    if (this.video.length) {
      this.videoEmbed = this.video.find('.c-embed').clone();
      this.video.html('');
    }
  }

  events() {
    this.doc.on('aos:in', ({ detail }) => {
      const det = detail.detail || detail; // for ie, edge detail.detail
      const elem = $(det);

      if (elem.hasClass('js-intro-text')) {
        elem.addClass('aos-done');
      }
    });
  }

  clearDelays() {
    if (!this.clearContainer.length) {
      return;
    }

    const elements = this.clearContainer.find('[data-aos]');

    if (elements.length) {
      elements.each((i, el) => {
        if (!$(el).hasClass('aos-animate')) {
          $(el).removeAttr('data-aos-delay');
        }
      });
    }
  }

  paragraphs() {
    this.ps = $('.is-animated');

    if (this.ps.length) {
      $.each(this.ps, (i, p) => {
        const paragraph = $(p);
        // const headingsBefore = paragraph.parent().find('.is-line').length;

        paragraph.attr({
          'data-aos': 'fade-up',
          'data-aos-duration': 700,
          'data-aos-delay': 500,
        });
      });
    }
  }

  headings() {
    this.headings = $('.c-main')
      .find('h2, h3, h4, h5, h6, .h2')
      .not('.no-anim');

    if (this.headings.length) {
      $.each(this.headings, (hi, h) => {
        const heading = $(h);

        if (heading.closest('.no-anim').length) {
          return;
        }
        const words = heading.html().split(/\s*(<[^>]*>)/g);
        let wordsArray = [];

        $.each(words, (w, word) => {
          if (word.match(/^<.*>$/)) {
            wordsArray.push(word);
          } else {
            const ws = word.match(/[^\s]+/g);

            if ($.isArray(ws)) {
              wordsArray.push(...ws);
            }
          }
        });

        if (wordsArray.length) {
          wordsArray = wordsArray.map(word => {
            let w = '';
            if (word.match(/^<.*>$/)) {
              w = word;
            } else {
              w = `<span class="is-word">${word} </span>`;
            }

            return w;
          });
        }

        heading.html(wordsArray.join(' '));

        const wordsElems = heading.find('.is-word').toArray();

        if (wordsElems.length) {
          const lines = [0];

          $.each(wordsElems, (index, el) => {
            const pos = $(el).position().top;
            const nextIndex = index + 1;
            const isLast = nextIndex === wordsElems.length;

            if (index > 0 && !isLast) {
              const nextPos = $(wordsElems[nextIndex]).position().top;

              if (pos !== nextPos) {
                lines.push(index, nextIndex);
              }
            } else if (isLast) {
              lines.push(index);
            }
          });

          if (lines.length) {
            for (let i = 0; i < lines.length; i += 1) {
              if ((i + 1) % 2 === 0) {
                const start = lines[i - 1];
                const end = lines[i + 1];
                let firstElem = $(wordsElems[start]);
                const lastElem = $(wordsElems[end]);

                // console.log(firstElem)
                // console.log(lastElem)
                // console.log(firstElem.nextUntil(lastElem))
                if (firstElem.parent().hasClass('color')) {
                  firstElem = firstElem.parent();
                  firstElem
                    .addClass('is-word')
                    .find('.is-word')
                    .contents()
                    .unwrap();
                }

                $(firstElem)
                  .nextUntil(lastElem)
                  .addBack()
                  .wrapAll(
                    '<span class="is-line"><span class="is-line-inner"></span></span>',
                  );
              }
            }

            let timeout = -700;
            heading.find('.is-line-inner').each((i, el) => {
              $(el).attr({
                'data-aos': 'fade-up',
                'data-aos-duration': 700,
                'data-aos-delay': i === 0 ? 0 : i * 350,
              });
              timeout += 700;

              if (
                heading.hasClass('js-hero-image-heading') &&
                i + 1 === lines.length / 2
              ) {
                this.hero(heading, timeout);
              }
            });
          }
        }
      });
    }
  }

  hero(heading, timeout) {
    this.hero = heading.closest('.js-page-hero');
    const heroElems = [
      this.hero.find('.js-hero-image-text'),
      this.hero.find('.js-hero-hsc'),
      this.hero.find('.js-modal-video-btn'),
      this.hero.find('.js-hero-image-subtitle'),
    ];

    this.hero.find('.js-hero-image-subtitle').on('click', e => {
      e.preventDefault();

      $('body, html')
        .stop()
        .animate(
          {
            scrollTop: this.hero.height(),
          },
          500,
        );
    });

    const initialTime = timeout + 300;
    let t = initialTime;
    let tr = 0;

    for (let i = 0; i < heroElems.length; i += 1) {
      if (!heroElems[i].length) {
        tr += 300;
      }

      t += i * 300 - tr;

      t = t < initialTime ? initialTime : t;

      heroElems[i].attr('data-aos-delay', Math.abs(t));

      if (heroElems[i].hasClass('js-hero-image-subtitle')) {
        setTimeout(() => {
          heroElems[i].addClass('has-animated');
        }, t + 1000);
      }
    }
  }
}

export default new Aos();



// WEBPACK FOOTER //
// ./src/scripts/modules/aos.js